import { backToNative, setNavigationBar } from '@docs/common'
import { useEffect } from 'react'

import { useTranslation } from '@volcengine/i18n'
import Banner from 'assets/images/bh3/formating.png'

import useLanguageTrans from 'common/useLanguageTrans'
import styles from './index.module.scss'

const Formating = () => {
  useLanguageTrans()
  const { t } = useTranslation()

  useEffect(() => {
    setNavigationBar({
      title: t('h5_storage_edu_format', { defaultValue: 'Storage Drive Formatting' }),
    })
  })

  return (
    <div className={styles.Formating}>
      <div className={styles.Banner}>
        <img src={Banner} alt="banner" />
      </div>
      <div className={styles.Content}>
        <p>
          {t('h5_storage_edu_format_tips', {
            defaultValue:
              'Find the storage drive formatting feature here: \neufy Security App > HomeBase 3 Homepage > Storage > Format',
          })}
        </p>
      </div>
      <div className={styles.Op}>
        <button onClick={backToNative}>
          {t('h5_storage_edu_format_button', { defaultValue: 'Format Storage Drive' })}
        </button>
      </div>
    </div>
  )
}

export default Formating
